"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var semantic_ui_react_1 = require("semantic-ui-react");
var Auth_1 = require("../stores/Auth");
var Auth_2 = require("../services/Auth");
var RestUtilities_1 = require("../services/RestUtilities");
var Login_1 = require("./Login");
var Register_1 = require("./Register");
require("./NavMenu.css");
var authUser = Auth_1.default.getUser();
var authService = new Auth_2.default();
var NavMenu = /** @class */ (function (_super) {
    __extends(NavMenu, _super);
    function NavMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.logOut = function () {
            authService.logOut();
            window.location.reload();
        };
        _this.handleLoginModalOpen = function () {
            _this.setState({ loginModelOpen: true });
        };
        _this.handleRegisterModalOpen = function () {
            _this.setState({ registerModalOpen: true });
        };
        _this.handleLoginModalClose = function () {
            _this.setState({ loginModelOpen: false });
        };
        _this.handleRegisterModalClose = function () {
            _this.setState({ registerModalOpen: false });
        };
        _this.state = {
            loginModelOpen: false,
            registerModalOpen: false,
            cribHomeLink: ''
        };
        return _this;
    }
    NavMenu.prototype.componentDidMount = function () {
        var _this = this;
        RestUtilities_1.get('api/Application/GetCRIBHomeLink')
            .then(function (response) {
            if (!response.isError) {
                _this.setState({ cribHomeLink: response.content });
            }
        });
    };
    NavMenu.prototype.render = function () {
        var _a = this.state, loginModelOpen = _a.loginModelOpen, registerModalOpen = _a.registerModalOpen, cribHomeLink = _a.cribHomeLink;
        return (React.createElement("div", null,
            React.createElement(semantic_ui_react_1.Menu, { size: 'huge', inverted: true },
                React.createElement(semantic_ui_react_1.Container, null,
                    React.createElement(semantic_ui_react_1.Menu.Item, { as: react_router_dom_1.Link, to: "/", header: true },
                        React.createElement(semantic_ui_react_1.Image, { size: 'mini', src: process.env.PUBLIC_URL + '/images/logo.png', style: { marginRight: '1em' } }),
                        "CCPAP Home"),
                    React.createElement(semantic_ui_react_1.Menu.Item, { as: 'a', href: cribHomeLink, header: true }, "CRIB Home"),
                    React.createElement(semantic_ui_react_1.Menu.Menu, { position: 'right' }, authUser ? (React.createElement(semantic_ui_react_1.Menu.Item, null,
                        React.createElement(semantic_ui_react_1.Button, { onClick: this.logOut, content: 'Log Out', color: 'green', icon: 'user' }))) : (React.createElement(semantic_ui_react_1.Menu.Item, null,
                        React.createElement(Login_1.default, { modalOpen: loginModelOpen, handleClose: this.handleLoginModalClose }),
                        React.createElement(semantic_ui_react_1.Button, { style: { marginRight: '10px' }, onClick: this.handleLoginModalOpen, basic: true, color: 'green', content: 'Log In' }),
                        React.createElement(Register_1.default, { modalOpen: registerModalOpen, handleClose: this.handleRegisterModalClose }),
                        React.createElement(semantic_ui_react_1.Button, { onClick: this.handleRegisterModalOpen, basic: true, color: 'green', content: 'Register' })))))),
            [this.props.children].map(function (c) { return React.createElement("div", { style: { marginTop: "2em", marginBottom: "2em" } }, c); })));
    };
    return NavMenu;
}(React.Component));
exports.default = NavMenu;
//# sourceMappingURL=NavMenu.js.map